export enum ConciergeMessageType
{
    None = 0,
    CarbucksProfile = 1
}